import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import SiteHeader from '../../components/SiteHeader';
import SideBar from '../../components/SideBar';
import { Grid, Box, useMediaQuery, useTheme } from '@mui/material';

const AuthCompanyLayout = ({ children }) => {
  const theme = useTheme();
  const isMobileView = useMediaQuery(theme.breakpoints.down('lg'));
  const [isMobile, setIsMobile] = useState(false);

  useEffect(() => {
    setIsMobile(isMobileView);
  }, [isMobileView]);

  return (
    <main>
      <div className="authLogin">
        <Grid container>
          <Grid 
            item 
            width={{xs: 0, lg: 300}} 
            display={{xs: 'none', lg: 'block'}}
            sx={{ position: 'fixed', height: '100vh', zIndex: 1200 }}
          >
            <SideBar />
          </Grid>
          <Grid 
            item 
            width={{xs: '100%', lg: 'calc(100% - 300px)'}}
            sx={{ 
              marginLeft: { xs: 0, lg: '300px' },
              minHeight: '100vh'
            }}
          >
            <Grid item container>
              <Grid item xs={12}>
                <SiteHeader />
              </Grid>
              <Grid item xs={12}>
                {children}
              </Grid>
            </Grid>
          </Grid>
        </Grid>
      </div>
    </main>
  );
};

AuthCompanyLayout.propTypes = {
  children: PropTypes.node.isRequired,
};

export default AuthCompanyLayout;
